export const getItemFromSS = (key, defValue) => {
    try {
        return JSON.parse(sessionStorage.getItem(key)) || defValue;
    } catch {
        return defValue || {};
    }
};
